// =============================================================================
// components/ui/Icon.tsx — the ONE Ionicons import for the whole bare-RN app.
//
// MIGRATION (blueprint §1, swap #2): the Expo app imported `Ionicons` from
// `@expo/vector-icons` at 70+ sites. Bare RN uses `react-native-vector-icons`.
// Instead of editing 70 import lines to the vendor path, every screen + component
// imports the icon from HERE:
//
//     import { Icon } from '../components/ui/Icon';        // <Icon name="home" .../>
//     // or, to keep call sites that used <Ionicons .../> verbatim:
//     import { Ionicons } from '../components/ui/Icon';
//
// Both `Icon` and `Ionicons` are the SAME component (react-native-vector-icons
// Ionicons). The Ionicons glyph set + the `name`/`size`/`color` props are
// identical to @expo/vector-icons, so the swap is a pure import-path change.
//
// `IoniconName` is the glyph-name union — use it to type an `icon` prop:
//     icon?: IoniconName;
//
// NB: the iOS project must bundle `Ionicons.ttf` (Info.plist UIAppFonts + a
// Copy-Bundle-Resources / `npx react-native-asset` step) for glyphs to render —
// that is a P1/native step, not a JS one.
// =============================================================================
import Ionicons from 'react-native-vector-icons/Ionicons';

/** The Ionicons glyph-name union (drop-in for the old `keyof Ionicons.glyphMap`). */
export type IoniconName = React.ComponentProps<typeof Ionicons>['name'];

export { Ionicons };
export const Icon = Ionicons;
export default Ionicons;
